import { FC } from "react";
import AnimeFadeIn from "./AnimeFadeIn";

type Props = {
  titleJP: string;
  titleEn: string;
};

const SectionTitle: FC<Props> = ({ titleEn, titleJP }): JSX.Element => {
  return (
    <div className="flex flex-col-reverse gap-8 text-center">
      <AnimeFadeIn>
        <h2 className="font-bold text-[40px] laptop:text-[60px] leading-tight">
          {titleJP}
        </h2>
      </AnimeFadeIn>

      <AnimeFadeIn>
        <p
          style={{
            fontSize: 24,
          }}
          className="font-bold text-yellow"
        >
          {titleEn}
        </p>
      </AnimeFadeIn>
    </div>
  );
};
export default SectionTitle;
